import { render, staticRenderFns } from "./ThemeFooter.vue?vue&type=template&id=6354f596&scoped=true&"
import script from "./ThemeFooter.vue?vue&type=script&lang=js&"
export * from "./ThemeFooter.vue?vue&type=script&lang=js&"
import style0 from "./ThemeFooter.vue?vue&type=style&index=0&id=6354f596&lang=scss&scoped=true&"
import style1 from "./ThemeFooter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6354f596",
  null
  
)

export default component.exports